import { IS_BROWSER } from 'src/localConstants'
import { parseISO } from 'date-fns'
import { wrapPageElement as _wrapPageElement } from './gatsby-shared'

export const wrapPageElement = (props) => _wrapPageElement(props)

export const onClientEntry = () => {
  function addScript(jsFilePath, onLoad) {
    const js = document.createElement('script')
    js.type = 'text/javascript'
    js.src = jsFilePath

    document.head.appendChild(js)
    if (onLoad) js.onload = onLoad
  }

  function addWidget() {
    addScript('/widget.js')
  }

  const isWidget = window.location?.pathname.startsWith('/widget/')

  // Only load on local dev as we add this in gatsby-ssr.
  if (isWidget && process.env.NODE_ENV === 'development') {
    addScript('/zoid.min.js', addWidget)
  }
}

// We use use onPreRouteUpdate instead of onRouteUpdate as it runs before wrapPageElement,
// so we can actually update the location state as intended
export const onPreRouteUpdate = ({ location, prevLocation }) => {
  // https://stackoverflow.com/questions/54942047/how-to-get-previous-url-in-react-gatsby/54950614

  const hasPrevLocation = !!prevLocation
  // return either current or prev location /class
  const parseDay = (_location) =>
    parseISO(_location.split('/')[3].substring(0, 10))

  // Only add if user directly navigates to class page without any history
  let _prevClassDay = false
  if (!hasPrevLocation) {
    const isClassPage = location.pathname.startsWith('/class/')
    const isPrevClassPage = location?.state?.prevLocation?.startsWith('/class/')
    if (isClassPage) {
      _prevClassDay = parseDay(location.pathname)
    }
    if (isPrevClassPage) {
      _prevClassDay = parseDay(location.state.prevLocation)
    }
  }

  location.state = {
    ...location.state,
    prevLocation: hasPrevLocation
      ? prevLocation.pathname + prevLocation.hash + prevLocation.search
      : '/',
    prevClassDay: _prevClassDay,
  }
}

export const onServiceWorkerUpdateReady = () => {
  // TODO: Use a modal instead
  const answer =
    IS_BROWSER &&
    // eslint-disable-next-line no-alert
    window.confirm(
      `We have a new application update ready for you. ` +
        `Reload to display the latest version?`
    )

  if (answer === true && IS_BROWSER) {
    window.location.reload()
  }
}
